import { render } from "./AddProject.vue?vue&type=template&id=253ddb71&scoped=true"
import script from "./AddProject.vue?vue&type=script&lang=js"
export * from "./AddProject.vue?vue&type=script&lang=js"

import "./AddProject.vue?vue&type=style&index=0&id=253ddb71&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253ddb71"]])

export default __exports__